import { FaqAccordionItems } from '@app/widgets';

export const IOS_UDID_FINDER_FAQS: FaqAccordionItems[] = [
  {
    question: 'What is a UDID?',
    answer: [
      'A UDID (Unique Device Identifier) is a unique alphanumeric string assigned to every iPhone and iPad.',
      'It is used by developers to register devices for ad-hoc testing, beta distribution, and provisioning profiles.',
    ].join(' '),
  },
  {
    question: 'Why do I need to install a profile?',
    answer: [
      'Starting with iOS 12.2, Apple requires a configuration profile to retrieve device identifiers like the UDID.',
      'The profile is lightweight and only used to read your device information — it does not modify any settings.',
    ].join(' '),
  },
  {
    question: 'Is it safe to install the profile?',
    answer: [
      'Yes.',
      'The profile only requests your device information and does not modify any settings or install any certificates.',
      'No data is stored on our servers.',
    ].join(' '),
  },
  {
    question: 'How do I remove the profile after getting my UDID?',
    answer:
      'Go to Settings > General > VPN & Device Management, select the profile, and tap Remove Profile.',
  },
  {
    question: 'Can I find my UDID without a Mac?',
    answer: [
      'Yes, this tool works entirely on your iOS device.',
      'No Mac, Xcode, or iTunes is required.',
    ].join(' '),
  },
  {
    question: 'What information does this tool retrieve?',
    answer:
      'UDID, device name, serial number, IMEI, MEID, iOS version, and product type.',
  },
];
